<div class="pre-loader">
    <div class="pre-loader-content">
        <div class="loader"></div>
    </div>
</div>